import Icon from "@ant-design/icons";
import type { GetProps } from "antd";

type CustomIconComponentProps = GetProps<typeof Icon>;

const TaxSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path d="M2 8.57c0-1.197.482-1.93 1.48-2.486l4.11-2.287C9.743 2.6 10.82 2 12 2s2.257.6 4.41 1.797l4.11 2.287C21.517 6.64 22 7.373 22 8.57c0 .324 0 .487-.035.62c-.186.7-.821.811-1.434.811H3.469c-.613 0-1.247-.11-1.434-.811C2 9.056 2 8.893 2 8.569ZM4 10v8.5M8 10v8.5"></path>
      <path
        strokeLinecap="round"
        d="M11 18.5H5a3 3 0 0 0-3 3a.5.5 0 0 0 .5.5H11"
      ></path>
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m21.5 14.5l-7 7"
      ></path>
      <circle cx={15.25} cy={15.25} r={0.75}></circle>
      <circle cx={20.75} cy={20.75} r={0.75}></circle>
    </g>
  </svg>
);
const TaxIcon = (props: Partial<CustomIconComponentProps>) => {
  return <Icon component={TaxSvg} {...props} />;
};
export default TaxIcon;
